/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Datumteilnahmeworkshop22Inputs */

const de__field_datumteilnahmeworkshop22 = /** @type {(inputs: _Field_Datumteilnahmeworkshop22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum Teilnahme Workshop 2`)
};

/**

* @param {_Field_Datumteilnahmeworkshop22Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_datumteilnahmeworkshop22 = /** @type {((inputs?: _Field_Datumteilnahmeworkshop22Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Datumteilnahmeworkshop22Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_datumteilnahmeworkshop22(inputs)
});
export { _field_datumteilnahmeworkshop22 as "_field_datumTeilnahmeWorkshop2" }